import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnBA: CultureInfo = {
  name: 'en-BA',
  displayName: 'English (Bosnia & Herzegovina)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-BA',
  parent: CultureInfoEn
};
